import React, {useContext, useEffect, useState} from 'react';
import DashboardWidget from "./DashboardWidget";
import axios from "@common/axios";
import {ContentContext} from "@context/ContentContext";
import {UserContext} from "@context/UserContext";
import useCurrentConcept from "@hooks/useCurrentConcept";
import Button from "@common/Button";

const MyCourseNextTopicDashboardWidgetUSA = props => {
    const {...other} = props;
    const { content } = useContext(ContentContext);
    const { user } = useContext(UserContext);
    const { loadCurrentConcept } = useCurrentConcept();
    const [isLoading, setLoading] = useState(false);
    const [nextConcept, setNextConcept] = useState();

    const loadNextConcept = () => {
        if(content.currentTopic !== undefined && content.currentTopic.nextTopicId !== undefined) {
            setLoading(true);
            axios.get('/web/ui/content/topic/' + content.currentTopic.nextTopicId + '/firstConcept')
                .then(response => {
                    setNextConcept(response.data);
                    setLoading(false);
                });
        } else if(user.syllabusId !== undefined) {
            setLoading(true);
            axios.get('/web/ui/content/syllabus/' + user.syllabusId + '/firstConcept')
                .then(response => {
                    setNextConcept(response.data);
                    setLoading(false);
                });
        } else {
            setNextConcept(undefined);
            setLoading(false);
        }
    }

    const handleClick = conceptId => {
        loadCurrentConcept(conceptId);
    }

    useEffect(() => {
        loadNextConcept();
    }, []);

    return (
        <div>
            <h2>Continue your progress</h2>
            <div className={'ch-dashboard-usa-next-lesson'}>
                <DashboardWidget
                    isLoading={isLoading}
                    {...other}>
                    {nextConcept &&
                        <>
                        <div className={"ch-dashboard-usa-next-lesson-content"}>
                            <div>
                                <p className="ch-dashboard-lesson-link">
                                    {nextConcept.syllabusName} <span className="material-icons">chevron_right</span>
                                    {nextConcept.topicName} <span className="material-icons">chevron_right</span>
                                </p>
                                <h3 className={'ch-dashboard-usa-widget-heading'}>{nextConcept.conceptName}</h3>
                            </div>
                        </div>
                        <Button onClick={() => handleClick(nextConcept.conceptId)}>Go to
                            next lesson</Button>
                        </>
                    }
                </DashboardWidget>
            </div>
        </div>
    )
}

export default MyCourseNextTopicDashboardWidgetUSA;